export default class SmartNavigation {
  constructor() {
    this.hasAnalyzed = false;
    this.puterLoaded = false;
    this.isActive = false;
    this.cacheKey = `a11y-smart-skip-v3-${window.location.pathname}`;
  }

  enable() {
    this.isActive = true;
    this.checkAndInject();
  }

  disable() {
    this.isActive = false;
    const nav = document.querySelector('.a11y-smart-skip');
    if (nav) nav.remove();
    const loader = document.querySelector('.a11y-smart-loader');
    if (loader) loader.remove();
  }

  async checkAndInject() {
    const cached = localStorage.getItem(this.cacheKey);
    if (cached) {
        try {
            const links = JSON.parse(cached);
            this.injectMenu(links);
            return;
        } catch (e) {
            console.error('SmartNav Cache Error', e);
        }
    }

    await this.analyzePage();
  }

  async loadPuter() {
    if (window.puter) {
      this.puterLoaded = true;
      return;
    }
    
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.puter.com/v2/';
        script.onload = () => {
            this.puterLoaded = true;
            resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
  }

  async analyzePage() {
    const loader = this.injectLoader();

    try {
        if (!this.puterLoaded) await this.loadPuter();
        
        const simplifiedDom = this.getSimplifiedStructure();

        const prompt = `
            Create a "Table of Contents" for this page using the provided HTML structure.
            
            Focus ONLY on:
            1. HEADINGS (H1-H6) - these mark content sections.
            2. FORMS - specifically Search or Login.
            3. MAIN LANDMARKS (Main content, Footer, Header).
            
            Rules:
            - Ignore small buttons, links, or minor details.
            - Target the containing SECTION or DIV if possible, otherwise the Heading itself.
            - Extract at least 6-8 key sections if available.
            - "Add to Cart" -> target the Product Form or Product Heading.
            - "Contact" -> target the Contact Section.
            
            Return JSON array: [{"label": "Polish Name", "selector": "CSS_SELECTOR"}]
            
            HTML:
            ${simplifiedDom}
        `;

        const chatResponse = await window.puter.ai.chat(prompt, { model: 'gpt-4o-mini' });
        
        let links = [];
        let content = '';

        if (typeof chatResponse === 'string') content = chatResponse;
        else if (chatResponse?.message?.content) content = chatResponse.message.content;
        else if (chatResponse?.result?.message?.content) content = chatResponse.result.message.content;

        content = content.replace(/```json/g, '').replace(/```/g, '').trim();

        try {
            links = JSON.parse(content);
        } catch (e) {
            console.error('AI Parse Error', e, content);
            links = [
                { label: 'Treść główna', selector: 'main, #content' },
                { label: 'Szukaj', selector: '#search_widget, form[action*="search"]' }
            ];
        }

        localStorage.setItem(this.cacheKey, JSON.stringify(links));
        this.injectMenu(links);

    } catch (e) {
        console.error('SmartNav Analysis Error', e);
    } finally {
        loader.remove();
    }
  }

  getSimplifiedStructure() {
    const clone = document.body.cloneNode(true);
    
    const ignoredTags = ['SCRIPT', 'STYLE', 'SVG', 'PATH', 'NOSCRIPT', 'IFRAME', 'LINK', 'META', 'BR', 'HR', 'IMG', 'INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SPAN', 'I', 'STRONG', 'B', 'EM', 'SMALL'];
    
    ignoredTags.forEach(tag => {
        const elements = clone.querySelectorAll(tag);
        elements.forEach(el => el.remove());
    });

    clone.querySelectorAll('*').forEach(el => {
         if (el.getAttribute('aria-hidden') === 'true' || el.hasAttribute('hidden')) {
             el.remove();
         }
    });

    clone.querySelectorAll('*').forEach(el => {
        const allowedAttrs = ['id', 'class', 'role', 'action'];
        Array.from(el.attributes).forEach(attr => {
            if (!allowedAttrs.includes(attr.name)) {
                el.removeAttribute(attr.name);
            }
        });
        
        if (el.tagName === 'DIV' && el.innerHTML.trim() === '' && !el.id) {
            el.remove();
        }
    });

    return clone.innerHTML.substring(0, 15000);
  }

  injectLoader() {
    const div = document.createElement('div');
    div.className = 'a11y-smart-loader';
    div.innerText = 'AI analizuje nawigację...';
    div.setAttribute('role', 'status');
    document.body.prepend(div);
    return div;
  }

  injectMenu(links) {
    // Validate links exist
    const validLinks = links.filter(l => document.querySelector(l.selector));
    
    if (validLinks.length === 0) return;

    const nav = document.querySelector('.a11y-smart-skip') || document.createElement('nav');
    if (!nav.parentElement) {
        nav.className = 'a11y-smart-skip';
        nav.innerHTML = '<span class="a11y-smart-header">Nawigacja AI</span>';
        document.body.appendChild(nav);
    } else {
        // Clear existing if re-injecting
        nav.innerHTML = '<span class="a11y-smart-header">Nawigacja AI</span>';
    }
    
    const list = document.createElement('ul');
    
    validLinks.forEach(link => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#';
        a.innerText = link.label;
        a.className = 'a11y-skip-link';
        
        a.addEventListener('click', (e) => {
            e.preventDefault();
            const target = document.querySelector(link.selector);
            if (target) {
                target.setAttribute('tabindex', '-1');
                target.focus();
                // smooth scroll
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });

        li.appendChild(a);
        list.appendChild(li);
    });

    nav.appendChild(list);
  }
}
